module.exports = __webpack_public_path__ + "img/Banner-Program.2d8aae2d.svg";